import { FeatureFlag } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { useWidget } from '@swf/core/hooks/useWidget';
import { select } from '@swf/core/store';
import type { CasinoGameList as CasinoGameListProps } from '@swf/core/types/CasinoGameList';

import type { SLProps } from '../CasinoGameList/CasinoGameList';
import CasinoMetaTile from '../CasinoMetaTile/CasinoMetaTile';

import stylesDef from './GamesCardContent.scss';
import stylesSl from './GamesCardContentSL.scss';
import { sequencesDef, sequencesSl } from './layout';

export interface Props {
  games: CasinoGameListProps['games'];
  renderInfo?: CasinoGameListProps['renderInfo'];
  maxGames?: number;
  gameCategory: string;
  overlayHierarchy?: string;
}

const GamesCardContent: React.FC<Props> = (props) => {
  const { games, renderInfo, maxGames, gameCategory, overlayHierarchy } = props;
  const infoEnabled = useFeature(FeatureFlag.CasinoGameInfo);
  const isMobile = useSelector(select.device.isMobile);
  const safeMaxGames = maxGames ? Math.min(9, maxGames) : 9;
  const safeGames = games.slice(0, Math.min(safeMaxGames, games.length));
  const { widgetConfig } = useWidget();
  const { new_game_tile_view: newGameTileView = false, disable_icons: disableIcons = false } =
    widgetConfig as SLProps;
  const styles = newGameTileView ? stylesSl : stylesDef;
  const sequences = newGameTileView ? sequencesSl : sequencesDef;

  const list = safeGames.map((game, index) => (
    <CasinoMetaTile
      key={index}
      game={game}
      slide
      index={index}
      icon={sequences[safeGames.length - 1][index]}
      count={safeGames.length}
      renderInfo={renderInfo}
      gameDeckMosaic={safeGames.length >= 5}
      jackpotClassName={styles.jackpot}
      gameCategory={gameCategory}
      isNewSLView={newGameTileView}
      overlayHierarchy={overlayHierarchy}
      disableIcons={disableIcons}
      gameDeck
    />
  ));

  return list.length > 0 ? (
    <div
      className={classNames(
        styles.container,
        styles[`gameCount${safeGames.length}` as keyof typeof styles],
        renderInfo && isMobile && infoEnabled
      )}
    >
      {list}
    </div>
  ) : null;
};

export default GamesCardContent;
